export const DATE_INPUT_CONSTANTS = {
  dobErrorCodes: {
    dobMonthError: 1,
    dobYearError: 2,
    dobMonthYearError: 3,
    genericError: 4,
  },
  fieldLength: {
    fulldateFormatLength: 14,
    memberDobLength: 9,
  },
};
